import { GridContainer } from 'libs/ui';
import { Cashbox } from 'grids/cashbox/cashbox';

export const CashboxWrapper = (props) => {
  return (
    <GridContainer>
      <Cashbox {...props} />
    </GridContainer>
  );
};
